import { render } from "./MenuListSwiper.vue?vue&type=template&id=cd7b08de"
import script from "./MenuListSwiper.vue?vue&type=script&lang=js"
export * from "./MenuListSwiper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__